if (!Math.log10) {
    Math.log10 = function (t) {
        return Math.log(t) / Math.LN10;
    };
}
